module.exports = __webpack_public_path__ + "static/media/293801.ada773d1.png";